module.exports = __webpack_public_path__ + "stylesheets/political-landing_13ec297054b85d789fa082bb6c9a03ff.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/political-landing.less
// module id = Rpkd
// module chunks = 153